import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { CanActivateGuard } from './can-activate.guard';

import { SearchInventoryComponent } from '../routes/search-inventory-component/search-inventory.component';

import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ComponentsModule } from './components.module';

import { SearchCarsLandingComponent } from '../routes/search-cars-landing-component/search-cars-landing.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CaptchaModule } from 'primeng/captcha';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { StepsModule } from 'primeng/steps';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';

import { SearchCarsComponent } from '../routes/search-cars-component/search-cars.component';
import { RequestQuoteComponent } from '../routes/search-inventory-component/request-quote-component/request-quote.component';
import { LeaseOptionsComponent } from '../routes/search-inventory-component/request-quote-component/lease-options/lease-options.component';

import { MechanicalOptionsComponent } from '../routes/search-inventory-component/request-quote-component/mechanical-options/mechanical-options.component';
import { HopperCartOptionsComponent } from '../routes/search-inventory-component/request-quote-component/mechanical-options/cart-types/hopper-cart-options/hopper-cart-options.component';
import { PressureCartOptionsComponent } from '../routes/search-inventory-component/request-quote-component/mechanical-options/cart-types/pressure-cart-options/pressure-cart-options.component';
import { GeneralCartOptionsComponent } from '../routes/search-inventory-component/request-quote-component/mechanical-options/cart-types/general-cart-options/general-cart-options.component';
import {
  MY_WINDOW_TOKEN,
  QuizSubmitErrorComponent,
} from '../routes/quiz-submit-error-component/quiz-submit-error.component';
import { SideNavigationComponent } from '../routes/search-inventory-component/request-quote-component/side-navigation/side-navigation.component';
import { DndDirective } from '../routes/search-inventory-component/request-quote-component/dnd.directive';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReviewComponent } from '../routes/search-inventory-component/request-quote-component/review/review.component';
import { YourSelections } from '../routes/search-inventory-component/request-quote-component/your-selections/your-selections.component';
import { ConfirmationService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OnlyNumber } from '../../shared/onlynumber.directive';
import { TableModule } from 'primeng/table';
import { CanActivateSearchGuard } from './can-activate-search.guard';
const landingPageRoute: Route = {
  path: '',
  component: SearchCarsLandingComponent,
  canActivate: [CanActivateGuard],
  data: { title: 'Landing Page' }, // Add the title here
};

const errorRoute: Route = {
  path: 'error',
  component: QuizSubmitErrorComponent,
  data: { title: 'Error Page' }, // Add the title here
};

const searchCarsRoute: Route = {
  path: 'search-cars',
  component: SearchCarsComponent,
  canActivate: [CanActivateGuard],
  data: { title: 'Search Cars' }, // Add the title here
};

const requestQuoteRoute: Route = {
  path: 'request-quote',
  component: RequestQuoteComponent,
  canActivate: [CanActivateGuard],
  canDeactivate: [CanDeactivateGuard],
  data: { title: 'Request Quote' }, // Add the title here
};

const searchInventoryChildren: Routes = [
  landingPageRoute,
  searchCarsRoute,
  requestQuoteRoute,
  errorRoute,
];

const searchInventoryRoute: Route = {
  path: 'search-inventory',
  component: SearchInventoryComponent,
  canActivate: [CanActivateSearchGuard],
  children: searchInventoryChildren,
  data: { title: 'Railcar Search' }, // Add the title here
};

const searchInventoryRoutes: Routes = [searchInventoryRoute];

@NgModule({
  declarations: [
    SearchInventoryComponent,
    RequestQuoteComponent,
    SearchCarsLandingComponent,
    DndDirective,
    ReviewComponent,
    LeaseOptionsComponent,
    MechanicalOptionsComponent,
    HopperCartOptionsComponent,
    PressureCartOptionsComponent,
    GeneralCartOptionsComponent,
    SearchCarsComponent,
    QuizSubmitErrorComponent,
    SideNavigationComponent,
    YourSelections,
    OnlyNumber,
  ],

  imports: [
    CommonModule,
    ComponentsModule,
    DropdownModule,
    InputTextModule,
    TooltipModule,
    MessagesModule,
    MessageModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    BrowserAnimationsModule,
    ButtonModule,
    CalendarModule,
    CaptchaModule,
    CheckboxModule,
    DividerModule,
    CardModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    InputTextareaModule,
    InputTextModule,
    StepsModule,
    TooltipModule,
    ConfirmDialogModule,
    HttpClientModule,
    RadioButtonModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    TableModule,
    RouterModule.forChild(searchInventoryRoutes),
    FlexLayoutModule,
  ],

  exports: [RouterModule, OnlyNumber, OnlyNumber],
  providers: [
    CanDeactivateGuard,
    ConfirmationService,
    CanActivateGuard,
    CanActivateSearchGuard,
    { provide: MY_WINDOW_TOKEN, useValue: window },
  ],
})
export class SearchInventoryRoutingModule {}
